import React,{useEffect,useRef}from "react";
import {Box,Typography,Button,useTheme}from "@mui/material";
import gsap from "gsap";
import BecomePartner from "./becomePartner";
import { setupPartnersAnimation } from "../animations";
import { colors } from "../../../../theme/colors";

import chainlinkImg from "../../../../static/Images/partners/chainlink.png";
import polygonImg from "../../../../static/Images/partners/polygon.png";
import binanceImg from "../../../../static/Images/partners/binance.png";
import coinGeckoImg from "../../../../static/Images/partners/coinGecko.png";
import metaMaskImg from "../../../../static/Images/partners/MetaMask.png";
import trustWalletImg from "../../../../static/Images/partners/TrustWallet.png";
import walletConnectImg from "../../../../static/Images/partners/WalletConnect.png";

const partners=[
  {
    name:"Chainlink",
    className:"partner-chainlink",
    image: chainlinkImg
  },
  {
    name:"Polygon",
    className:"partner-polygon",
    image: polygonImg
  },
  {
    name:"Binance",
    className:"partner-binance",
    image: binanceImg
  },
  {
    name:"CoinGecko",
    className:"partner-coingecko",
    image: coinGeckoImg
  },
  {
    name:"MetaMask",
    className:"partner-metamask",
    image: metaMaskImg
  },
  {
    name:"Trust Wallet",
    className:"partner-trust",
    image: trustWalletImg
  },
  {
    name:"WalletConnect",
    className:"partner-walletconnect",
    image: walletConnectImg
  }
];

const Partners=()=>{
  const sectionRef=useRef(null);
  const partnerRefs=useRef([]);
  const theme=useTheme();

  useEffect(()=>{
    const section=sectionRef.current;
    const partnerCards=partnerRefs.current;

    if(!section)return;

    let cleanupAnimation;
    const ctx=gsap.context(()=>{
      cleanupAnimation = setupPartnersAnimation(section, partnerCards);
    },section);

    return()=>{
      if (cleanupAnimation) cleanupAnimation();
      ctx.revert();
    };
  },[]);

  return(
    <Box
      ref={sectionRef}
      component="section"
      className="partners-section"
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        background: theme.palette.background.paper,
        color: colors.home.navyDeep,
        pt: { xs: '10px', md: '20px' },
        pb: { xs: '5px', md: '10px' },
      }}
    >

      <Box className="partners-header" sx={{
        width: { xs: 'calc(100% - 40px)', sm: '90%', md: 'min(1400px, 88%)' },
        margin: '0 auto',
        textAlign: 'center',
      }}>
        <Typography className="partners-eyebrow" sx={{
          fontSize: { xs: '11px', md: '13px' },
          fontWeight: 700,
          letterSpacing: '2.5px',
          color: colors.slate[500],
          mb: '5px',
        }}>
          OUR PARTNERS
        </Typography>

        <Typography className="partners-heading" sx={{
          fontSize: { xs: '32px', sm: '40px', md: '46px', lg: '52px' },
          fontWeight: 700,
          lineHeight: 1.08,
          letterSpacing: { xs: '-0.8px', md: '-1.5px' },
          mb: '5px',
        }}>
          Building the future together.
        </Typography>

        <Typography className="partners-description" sx={{
          maxWidth: '650px',
          margin: '0 auto',
          fontSize: { xs: '15px', sm: '16px', md: '17px' },
          lineHeight: { xs: 1.6, md: 1.7 },
          color: colors.slate[500],
        }}>
          Working with trusted technology and ecosystem partners
          to build a secure, transparent, and reliable gaming platform.
        </Typography>
      </Box>

      <Box className="partners-stage" sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        padding: { xs: '0px 0 5px', md: '0px 0 15px' },
      }}>

        <Box className="partners-row" sx={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: '5px 10px', sm: '5px 15px', md: '5px 20px' },
          padding: { xs: '0 20px', md: '0 6%' },
          willChange: "transform",
        }}>
          {partners.map((partner,index)=>(
            <Box
              key={partner.name}
              ref={element=>{
                partnerRefs.current[index]=element;
              }}
              className={`partner-card ${partner.className}`}
              sx={{
                position: "relative",
                width: { xs: '160px', sm: '200px', md: '240px', lg: '280px' },
                height: { xs: '80px', sm: '100px', md: '120px', lg: '140px' },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                cursor: "default",
                willChange: "transform",
              }}
            >
              <Box component="img" src={partner.image} alt={partner.name} className="partner-logo" sx={{
                position: "relative",
                zIndex: 1,
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }} />
            </Box>
          ))}
        </Box>

      </Box>

      <BecomePartner />

    </Box>
  );
};

export default Partners;